import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Copier — deux documents superposés duotone */
export const CopyIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Document arrière menthe */}
      <rect x="4" y="3" width="11" height="14" rx="2" fill="var(--equiply-icon-bg)" fillOpacity="0.5" />
      <rect x="4" y="3" width="11" height="14" rx="2" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Document avant bleu (avec fond pour masquer) */}
      <rect x="9" y="7" width="11" height="14" rx="2" fill="hsl(var(--background))" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Lignes sur doc avant */}
      <path d="M12 11.5h5M12 14.5h4" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
);
CopyIcon.displayName = "CopyIcon";
